import z from 'zod';

export const pp_championshipCaddieZodObject = {
  championshipCaddie: z.object({
    id: z.string().nullable(),
    name: z.string().nullable().optional(),
    registrationStatus: z.string().nullable().optional(),

    antiCorruptionAndBettingPolicyAcceptance: z.boolean().nullable().optional(),
    caddieAddressSectionComplete: z.boolean().nullable().optional(),
    caddieContactSectionComplete: z.boolean().nullable().optional(),
    hasStartedPreRegistration: z.boolean().nullable().optional(),
    championshipAddressLine1: z.string().nullable().optional(),
    championshipAddressLine2: z.string().nullable().optional(),
    championshipCountry: z.string().nullable().optional(),
    championshipCountyOrState: z.string().nullable().optional(),
    championshipEmail: z.string().nullable().optional(),
    championshipMobile: z.string().nullable().optional(),
    championshipPlayer: z.string().nullable().optional(),
    championshipPostcodeOrZipcode: z.string().nullable().optional(),
    championshipTownOrCity: z.string().nullable().optional(),
    contact: z.string().nullable().optional(),
    emailChange: z.string().nullable().optional(),
    firstName: z.string().nullable().optional(),
    fridayTicket: z.string().nullable().optional(),
    lastName: z.string().nullable().optional(),
    mobileChange: z.string().nullable().optional(),
    saturdayTicket: z.string().nullable().optional(),
    sundayTicket: z.string().nullable().optional(),
    thursdayTicket: z.string().nullable().optional(),
    ticketingContactName: z.string().nullable().optional(),
    yardageBook: z.string().nullable().optional(),
  }),
};
